import { render } from "./UIButton.vue?vue&type=template&id=8d9e2f5c&ts=true"
import script from "./UIButton.vue?vue&type=script&lang=ts"
export * from "./UIButton.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__